var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReaction2Active(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.25 24C40.25 15.025 32.975 7.75 24 7.75C15.025 7.75 7.75 15.025 7.75 24C7.75 32.975 15.025 40.25 24 40.25C32.975 40.25 40.25 32.975 40.25 24ZM4 24C4 12.9547 12.9547 4 24 4C35.0453 4 44 12.9547 44 24C44 35.0453 35.0453 44 24 44C12.9547 44 4 35.0453 4 24ZM17.875 28.8516C19.0625 30.1328 21.0938 31.5 24 31.5C26.9062 31.5 28.9375 30.1328 30.125 28.8516C30.8281 28.0938 32.0156 28.0391 32.7734 28.7422C33.5312 29.4453 33.5859 30.6328 32.8828 31.3906C31.1641 33.25 28.1953 35.25 24.0078 35.25C19.8203 35.25 16.8438 33.2578 15.1328 31.3906C14.4297 30.6328 14.4766 29.4453 15.2422 28.7422C16.0078 28.0391 17.1875 28.0859 17.8906 28.8516H17.875ZM15.2812 20.25C15.2812 18.8695 16.4008 17.75 17.7812 17.75C19.1617 17.75 20.2812 18.8695 20.2812 20.25C20.2812 21.6305 19.1617 22.75 17.7812 22.75C16.4008 22.75 15.2812 21.6305 15.2812 20.25ZM30.2812 17.75C31.6617 17.75 32.7812 18.8695 32.7812 20.25C32.7812 21.6305 31.6617 22.75 30.2812 22.75C28.9008 22.75 27.7812 21.6305 27.7812 20.25C27.7812 18.8695 28.9008 17.75 30.2812 17.75Z",
    fill: "#FDC300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReaction2Active);
export default __webpack_public_path__ + "static/media/reaction-2-active.1592a6d13423fea08c45062dfd50478c.svg";
export { ForwardRef as ReactComponent };